import React from 'react';
import "./loading.css"

const Loading = () => {
  return (
    <div className="loader"></div>
  )
}

export default Loading